import { useCallback } from 'react';
import { LineBreak } from '@direct-frontend/components';
import { alertSrc } from '#shared/assets';
import { useConfirm } from '#shared/lib/hooks';
import { pluralize } from '#shared/lib/string';
import { productsTestIds } from '#shared/lib/testids';

export const useProductsDeleteConfirm = () => {
    const { confirm, renderConfirmModal } = useConfirm();

    const confirmDelete = useCallback(
        async ({ productCount, cardCount }: { productCount: number; cardCount?: number }) => {
            const products = pluralize(productCount, '%d товар', '%d товара', '%d товаров');
            const cards = cardCount
                ? pluralize(cardCount, '%d карточку товара', '%d карточки товара', '%d карточек товара')
                : '';
            const description = cardCount ? cards : products;

            return confirm({
                title: (
                    <>
                        Перенести в архив
                        <LineBreak mode="compact" />
                        {description}
                    </>
                ),
                bodyText: 'Потом можно будет восстановить',
                imageSrc: alertSrc,
                applyText: 'Перенести в архив',
                cancelText: 'Отменить',
                'data-testid': productsTestIds.archiveConfirmModal,
                cancelButtonTestId: productsTestIds.archiveCancel,
            });
        },
        [confirm]
    );

    return { confirm: confirmDelete, ProductsDeleteModal: renderConfirmModal() };
};
